import DPTextBox from "framework/components/DPTextBox";
import React from "react";
import { Button, Col, Label, Row } from "reactstrap";
import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from "react"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic";
import DPSwitch from "framework/components/DPSwitch";


export const UnlockUserContent = ({
    formInputsUnlock,
    formInputChangeUnlock,
    validateUserCode,
    unlockUserModelTrigger,
    unlockUserGetSelectedRow,
    unlockUserModelOpen,
    menuName,
    menuCode
}) => {
    const ApiURL = window.Links.ApiURL
    return (
        <>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="User Code"
                        textType="text"
                        placeholder="User Code"
                        maxLength="20"
                        name={"usercode"}
                        value={formInputsUnlock.usercode}
                        onChange={formInputChangeUnlock}
                        onBlur={(e) => validateUserCode(e.target.value)}
                    />
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="User Name"
                        textType="text"
                        placeholder="User Name"
                        maxLength="50"
                        name={"userName"}
                        value={formInputsUnlock.userName}
                        onChange={formInputChangeUnlock}
                        disabled={true}
                        onBlur={(e) => validateUserCode(e.target.value)}
                    />
                </Col>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Button
                                color="success"
                                className="btn-sm"
                                size='sm'
                                onClick={e => {
                                    unlockUserModelTrigger()
                                }}
                                style={{ width: 'auto' }}
                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <DPSearchBoxDynamic
                columns={[]}
                mainTitle={"User Search"}
                isOpen={unlockUserModelOpen}
                toggle={unlockUserModelTrigger}
                getSelect={unlockUserGetSelectedRow}
                APIURL={ApiURL}
                URLPath={"USER"}
                MenuCode={menuCode}
                KeyVal={"USE"}
                searchBy={"UH_ID"}
                FilterStr={'a'}
            />
        </>
    )


};